import React, { memo, useState } from "react";
import {
  Grid,
  Button,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import OptionalToolTip from "../../../common/toolTip/OptionalToolTip";

import { FieldArray, FormikProps, useFormikContext } from "formik";
import Confirm from "../../../common/confirm/Confirm";
import { Data, Processor } from "../../../store/merchant/types";
import pageStyles from "./../../../pages/pageStyles";
import { Add, Delete, ExpandMore, Memory } from "@mui/icons-material";
import MerchantProcessorForm from "./MerchantProcessorForm";

interface Props {
  isUpdateAllowed?: boolean;
}

const EditMerchantProcessorComponent = (props: Props) => {
  const formikProps = useFormikContext();
  const { values } = formikProps as FormikProps<Data>;
  const styles = pageStyles();

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(0);

  const { isUpdateAllowed } = props;

  const createProcessor = (): Processor => {
    return {
      ProcessorName: "",
      MID: "",
      AdditionalData: [],
    };
  };

  return (
    <FieldArray
      name="attributes.Processor"
      render={(arrayHelpers) => {
        return (
          <>
            {values.attributes?.Processor?.map(
              (processor: Processor, index) => {
                return (
                  <Accordion key={index} className={styles.Accordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls={`${index}_content`}
                      id={`${index}_header`}
                    >
                      <Box className={styles.processorTitleWrapper}>
                        <Typography className={styles.processorTitle}>
                          <Memory style={{ marginRight: "5px" }} />
                          {`Processor ${processor.ProcessorName}`}
                        </Typography>
                        <OptionalToolTip
                          tooltip={
                            isUpdateAllowed
                              ? null
                              : "Not applicable in this section"
                          }
                        >
                          <Button
                            color="secondary"
                            variant="outlined"
                            onClick={(): void => {
                              setDeleteItemId(index);
                              setShowConfirm(true);
                            }}
                            size="small"
                            startIcon={<Delete />}
                            disabled={!isUpdateAllowed}
                          >
                            Delete
                          </Button>
                        </OptionalToolTip>
                      </Box>

                      <Confirm
                        isOpen={showConfirm}
                        onCancel={() => setShowConfirm(false)}
                        onConfirm={() => {
                          arrayHelpers.remove(deleteItemId);
                          setShowConfirm(false);
                        }}
                        title="Delete Processor"
                        icon="danger"
                        confirmLabel="Delete"
                        contentText={`You are about to delete a Processor`}
                      />
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        background: "var(--dmg-bg)",
                        borderTop: "1px solid var(--dmg-gray-200)",
                        padding: "16px",
                        marginTop: "16px",
                      }}
                    >
                      <Grid container style={{ marginTop: "15px" }}>
                        <Grid item xs={12}>
                          <MerchantProcessorForm
                            index={index}
                            disabled={!isUpdateAllowed}
                            processor={processor}
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              }
            )}
            <Grid item xs={12}>
              <Box textAlign="center">
                <OptionalToolTip
                  tooltip={
                    isUpdateAllowed ? null : "Not applicable in this section"
                  }
                >
                  <Button
                    color="primary"
                    variant="contained"
                    size="medium"
                    endIcon={<Add />}
                    disabled={!isUpdateAllowed}
                    onClick={() => {
                      arrayHelpers.push(createProcessor());
                    }}
                    style={{ marginTop: "15px" }}
                  >
                    Create Processor
                  </Button>
                </OptionalToolTip>
              </Box>
            </Grid>
          </>
        );
      }}
    />
  );
};

export default memo(EditMerchantProcessorComponent);
